// extracted by mini-css-extract-plugin
module.exports = {"card":"K50c3ktWKyw9qoPNl7O8","value":"OJmuQKL8arYfus352oJg"};